import { addSeperatorToInput } from "src/helper";
import { ICCOrderbooksResp } from "src/Interfaces/ccOrder";

interface IProps {
  info?: ICCOrderbooksResp | null;
}

const InfoBox = ({ info }: IProps) => {
  const formatValue = (value?: string | number | null) => {
    const formatted = addSeperatorToInput(
      value?.toString(),
      "negativeDecimalNumbers",
    );

    return typeof formatted === "string" && formatted.startsWith("-")
      ? `${formatted.slice(1)}-`
      : formatted;
  };

  const item = (label: string, value?: string | number | null) => (
    <div className="flex flex-row justify-start items-center gap-2">
      <div>{label}</div>
      <div className="font-bold" dir="ltr">
        {formatValue(value)}
      </div>
    </div>
  );

  return (
    <div className="border-2 border-gray-300 rounded p-1 text-xs mt-5 flex flex-col gap-3 !whitespace-nowrap">
      <div className="grid grid-cols-3 gap-x-8">
        {item("% بازده رول-روزانه:", info?.dailyRollGain)}
        {item(
          "% بازده خالص ارزش زمانی رول-روزانه:",
          info?.rollTimeDecayInvolveddFundRatioDaily,
        )}
        {item(
          "%بازده ارزش زمانی طول رول-روزانه:",
          info?.dailyNetGainTimeRangeRollPercent,
        )}
      </div>
      <div className="grid grid-cols-3 gap-x-8">
        {item("% بازده روزانه:", info?.gainAfterCommissionDaily)}
        {item("% بازده روزانه آفست:", info?.gainAfterCommissionDailyOffset)}
        {item("ب ت لحظه ای:", info?.pairPosition)}
      </div>
    </div>
  );
};

export default InfoBox;
